<ng-container *transloco="let t">
  <z-modal-listbox
    popupWindowIcon="fad fa-earth-americas"
    popupWindowTitle="{{ t('core.layout.header.select_language.change_language') }}"
    selectButtonLabel="{{ t('core.layout.header.select_language.select_language') }}"
    cancelButtonLabel="{{ t('core.layout.header.select_language.cancel') }}"
    [display]="authService.displayChangeLanguage$ | async"
    [displayColumn1]="false"
    [popupFilter]="false"
    [list]="languageList"
    (selectValue)="selectLanguage($event)"
    [style]="{ height: '10rem' }"
    dialogStyleClass="dialog-small"
  ></z-modal-listbox>
</ng-container>
